// extracted by mini-css-extract-plugin
export var divider = "_dx-7";
export var itemsToggle = "_dx-8";
export var mergeModal = "_dx-1";
export var optionCard = "_dx-4";
export var radioGroup = "_dx-6";
export var radioOption = "_dx-0";
export var selected = "_dx-5";
export var shipmentOptions = "_dx-2";
export var tableOptions = "_dx-3";